import { v4 } from "uuid";

export type CloudfrontError<T = any> = { errorId: string } & T;

export function buildCloudfrontError<T>(error: T): CloudfrontError<T> {
    const errorId = v4();
    return { errorId, ...error };
}
